import React from "react";

const AppLayout = ({children}) => {
  return (
    <div>{children}</div>
  )
};

export default AppLayout
